// Desktop day columns shown at once (forced from the `lg` breakpoint up).
export const VISIBLE_DAY_COUNT = 5;

// Initial / default column count for the narrow (mobile) focused day strip.
export const DEFAULT_MOBILE_DAY_COUNT = 3;

// Matches Tailwind `lg:` (see SpecialistShow / booking panels).
export const DESKTOP_BREAKPOINT_PX = 1024;

// Matches Tailwind w-16 day columns + gap-6 between them, and size-11 chevrons
// with gap-2 around the centered group (see ServiceSlotsCalendar focused view).
const DAY_COLUMN_WIDTH = 64;
const DAY_COLUMN_GAP = 24;
const DAY_NAV_CHEVRON_SIZE = 44;
const DAY_NAV_OUTER_GAP = 8;

export function isDesktopDayStrip() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT_PX}px)`).matches;
}

// How many fixed-width day columns fit in `containerWidth` (px).
export function fitDayColumns(containerWidth, { min = 1, max = VISIBLE_DAY_COUNT } = {}) {
  const fixed = DAY_NAV_CHEVRON_SIZE * 2 + DAY_NAV_OUTER_GAP * 2;
  const perColumn = DAY_COLUMN_WIDTH + DAY_COLUMN_GAP;
  const fit = Math.floor((containerWidth - fixed) / perColumn);
  return Math.min(max, Math.max(min, fit));
}

// Desktop always uses VISIBLE_DAY_COUNT; mobile fits as many w-16 columns as width allows.
export function resolveDayColumns(containerWidth, {
  min = 1,
  max = VISIBLE_DAY_COUNT,
  desktopCount = VISIBLE_DAY_COUNT,
} = {}) {
  if (isDesktopDayStrip()) return desktopCount;
  return fitDayColumns(containerWidth, { min, max });
}
